import {makeStyles, Theme} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    minWidth: 120,
    backgroundColor: "#FFFFFF",
    "& .MuiSelect-root": {
      padding: 10,
    },
  },

  title__province: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    margin: "15px 0",
    "& >h6": {
      fontSize: 28,
      fontWeight: 500,
    },
  },
}));

export default useStyles;
